import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/loading';
import LocaleSelector from 'components/locale/selector';
import HelpLink from 'components/help-link';
import ModalActions from 'components/modal/actions';
import ButtonLink from 'components/button/button-link';
import { classNames } from 'utils';

export default class DropdownDialog extends React.PureComponent {
  static propTypes = {
    devtools: PropTypes.object,
  };

  render() {
    const {
      title,
      subtitle,
      actions,
      width = 400,
      minWidth,
      maxWidth,
      className,
      children,
      localized,
      externalLink,
      devtools,
      helpLink = true,
      overrideHelpLinkKey = null,
      icon = null,
      loading = false,
    } = this.props;

    return (
      <div
        className={classNames('dropdown-menu-dialog', className)}
        style={{
          width,
          minWidth,
          maxWidth,
        }}
      >
        {loading ? (
          <div className="dropdown-menu-dialog-loading">
            <Loading size={32} />
          </div>
        ) : (
          <>
            <div className="dropdown-menu-dialog-header">
              {title && (
                <h4 className="dropdown-menu-dialog-header-title">
                  {title}

                  {helpLink && (
                    <HelpLink
                      sectionName={title}
                      isModal={true}
                      overrideKey={overrideHelpLinkKey}
                    />
                  )}
                  {icon && icon}
                </h4>
              )}

              {subtitle && (
                <div className="dropdown-menu-dialog-header-subtitle">
                  {subtitle}
                </div>
              )}

              <div className="view-header-actions modal-header-actions">
                {localized && <LocaleSelector />}
                {externalLink && (
                  <ButtonLink type="secondary" size="sm" to={externalLink.link}>
                    {externalLink.label}
                  </ButtonLink>
                )}
              </div>
            </div>

            <div className="dropdown-menu-dialog-body">{children}</div>

            {(actions === undefined || actions) && (
              <ModalActions actions={actions} devtools={devtools} />
            )}
          </>
        )}
      </div>
    );
  }
}
